<template>
  <v-icon x-large :color="color">{{ icon }}</v-icon>
</template>

<script>

export default {
  name: "HealthScoreIcon",
  props: {
    satisfactionLevel: {
      type: Number,
      default: 5,
    }
  },
  computed: {
    icon() {
      switch (this.satisfactionLevel) {
        case 0:
          return 'mdi-emoticon-sad-outline';
        case 5:
          return 'mdi-emoticon-neutral-outline';
        case 10:
          return 'mdi-emoticon-happy-outline';
        default:
          return 'mdi-emoticon-neutral-outline';
      }
    },
    color() {
      switch (this.satisfactionLevel) {
        case 0:
          return 'red';
        case 5:
          return 'amber';
        case 10:
          return 'green';
        default:
          return 'amber';
      }
    }
  },
}
</script>

<style scoped>

</style>